import React, { useState } from 'react';
import { number, bool, string, oneOfType } from 'prop-types';
import moment from 'moment';
import { map, get } from 'lodash';
import { Menu as AntMenu } from 'antd';
import Link from '../../routes/Link';
import { OrderEventsConsumer } from '../../firebase/OrderEvents';
import { Text, IconBadge, HasPermissions, If } from '../../common';
import { withReloadable } from '../../../hoc';
import { Query } from '../../graphql';
import GET_COUNT_ORDERS from '../../../queries/GET_COUNT_ORDERS';
import GetUserSalesChannels from '../../graphql/getUserSalesChannels';
import { urlSisa, urlBase } from './../../../components/utils/changeUrlSisa';

let colorChange = '#1fa02e';

if (urlSisa() == urlBase()) {
    colorChange = '#4daea9';
}

const PendingPickingItem = withReloadable(({ color, ts }) => {
    return (
        <GetUserSalesChannels>
            {({ salesChannels, loading }) => {
                if (loading) return null;
                const QUERY_VARIABLES = {
                    range: [{
                        filter: 'shippingETA.init',
                        init: moment().startOf('day').format('YYYY-MM-DD 00:00:00'),
                        end: moment().startOf('day').add(1, 'days').format('YYYY-MM-DD 00:00:00')
                    }],
                    filters: [{
                        field: 'status',
                        value: ['1', '2', '20']
                    },
                    {
                        field: 'salesChannel',
                        value: map(salesChannels, ({ id }) => id)
                    }],
                    size: 100
                };
                return (
                    <Query query={GET_COUNT_ORDERS} variables={QUERY_VARIABLES} ts={ts}>
                        {({ data }) => {
                            const count = get(data, 'getCountOrders.count', 0);
                            return <IconBadge name='pie-chart' count={count} color={color} />;
                        }}
                    </Query>
                );
            }}
        </GetUserSalesChannels>
    );
}, ['ts']);

const PendingPickingMenuItem = ({ collapsed, index, path, currentPathname, ...props }) => {
    const [hovered, toggleHover] = useState(false);
    const isActive = currentPathname === path;
    const itemColor = isActive || hovered ? colorChange : '#ffffff';

    return (
        <HasPermissions to={['orders-pending-page:view']}>
            <AntMenu.Item
                onClick={() => this.props.navigate('/dashboard-ja')}
                title={<Text text='Pedidos en espera' color='white' />}
                onMouseEnter={() => toggleHover(!hovered)}
                onMouseLeave={() => toggleHover(!hovered)}
                key={`pending-audit-menu-item-${index}`}
                {...props}
            >
                <Link href={path} style={{ display: 'flex' }}>
                    <OrderEventsConsumer>
                        {({ ts }) => <PendingPickingItem color={itemColor} ts={ts} /> }
                    </OrderEventsConsumer>
                    <If
                        condition={!collapsed}
                        then={(<Text
                            color={itemColor}
                            text='Pedidos en espera'
                        />)}
                    />
                </Link>
            </AntMenu.Item>
        </HasPermissions>
    );
};

PendingPickingMenuItem.propTypes = {
    index: oneOfType([number, string]),
    collapsed: bool,
    path: string,
    currentPathname: string
};
export default PendingPickingMenuItem;
